<div class="modal-body  col-sm-12 form-group">
    <form [formGroup]="EscalationEntry" (ngSubmit)="onEscalationSubmit(EscalationEntry.value);">
        <div class="card">
            <div class="card-body">
                <div class="col-sm-3 height-34">Feature / Report</div>
                <input type="hidden" [formControlName]="'ReportID'" [(ngModel)]="this.ReportID" />
                <div class="col-sm-8 height-34">{{this.EscalationData.FeatureDs}}</div>
        
                <div class="col-sm-3 height-34">Setting</div>
                <div class="col-sm-8" style="padding-top:5px;">
                    <table>
                        <tr>
                            <th>Level</th>
                            <th>Mail Template</th>
                            <th>Active</th>
                        </tr>
        
                        <tr *ngFor="let ED of EscalationData.EDList; let i=index">
                            <td nowrap width="30%">
                                Level {{ED.LevelID}}
                            </td>
        
                            <td width="40%">
                                <input type="hidden" value={{ED.LevelID}} [formControlName]="'LevelID_'+ED.LevelID" />
                                <a class="link" style="color:#337ab7;" target="_blank" routerLink="/editor/{{ED.MailTemplate}}">Mail Template</a>
                            </td>
        
                            <td width="30%">
                                <input type="checkbox" [checked]="ED.recEnable" [(ngModel)]="ED.recEnable" [formControlName]="'recEnable_'+ED.LevelID" />
                            </td>
        
                    </table>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center mt-3">
            <button class="btn btn-primary submit-btn small " type="submit">
                Save
            </button>
        </div>
    </form>
</div>
